var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 11,
    y: 11,
    width: 17,
    height: 18,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAYAAAC9+TVUAAAB50lEQVQ4jWJkwA0MoBgEPjAwMDxgYGC4gKGcgYEBAAAA///CZkgBAwNDPpR9AEoLIBnYwMDAsBCumoGBAQAAAP//QsYghfuh2B6HGpD4eagakHoGBgYGBgAAAAD//0LGIMl6NEGQQpCrFNDEQepA6gUYGBgYAAAAAP//guEJDAwM87EY3M/AwPCfgYFhPRa5BWB5BgYGAAAAAP//AmGQLfex2AYCoHAAOT0Ah/ffMzAwCAAAAAD//2JmYGCIZ2Bg+IEjsF5AxUE0SA0yAPElGBgYFAAAAAD//2JiYGBwYGBg2IDDFSDnglyJzTsgcJCBgcEBAAAA//8CGQJyFigdoAOQGMiL2LwJAx8YGBgEAAAAAP//AhmCC+BMXCiAgYEBAAAA//8CGQJSjM82fECBgYHhAwAAAP//AhkCsi2BTEPsGRgYNgAAAAD//wIxYFGFzTWgRAVKJ6BoRgeQpMHAIAAAAAD//4JJgPILegqEpREYhuUdmMUgA/IZGBgYAAAAAP//QsagFAgyiFD4gAwAqYOkVgYGBgAAAAD//8LmfJANoASIbhhIMygHg7yOyGMMDAwAAAAA///ChkGaQfkIpBhkIMhWEA3ig8RRczgDAwMAAAD//yKE5aGaQDR2wMDAAAAAAP//AwAD0z/9yhAWnAAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationicon);
export default __webpack_public_path__ + "static/media/Information icon.0d2f774880146826f37f57806ae7d0e3.svg";
export { ForwardRef as ReactComponent };